module.exports = __webpack_public_path__ + "img/power-swiper-item (11).a9d46da1.png";